import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { X, Building } from "lucide-react";

export const DeptFilterChip = ({ id, onClear }) => {
  const [name, setName] = useState("");
  useEffect(() => {
    if (id === "none") { setName("No department"); return; }
    api.get("/departments").then((r) => setName(r.data.find((d) => d.id === id)?.name || "Department")).catch(() => {});
  }, [id]);
  return (
    <span data-testid="dept-filter-chip" className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full bg-blue-50 text-blue-800 border border-blue-200">
      <Building className="w-3.5 h-3.5" /> Department: <b>{name}</b>
      <button type="button" data-testid="dept-filter-clear" onClick={onClear} className="ml-0.5 hover:text-blue-950"><X className="w-3.5 h-3.5" /></button>
    </span>
  );
};
